import { getI18n } from 'react-i18next';

export const DEFAULT_DECIMAL_PLACES = 8;

export const PRICE_DECIMAL_PLACES = 2;

export const mathRound = (number: number, n: number) => {
  const d = Math.pow(10, n);
  return Math.round((number + Number.EPSILON) * d) / d;
};

export const toLocaleString = (value?: string | number, decimalPlaces?: number) => {
  const i18n = getI18n();

  return (
    value?.toLocaleString(i18n.language, {
      maximumFractionDigits: decimalPlaces || DEFAULT_DECIMAL_PLACES
    }) || ''
  );
};
